import { render, staticRenderFns } from "./HomePartnerCard.vue?vue&type=template&id=6a267cbc&scoped=true&"
import script from "./HomePartnerCard.vue?vue&type=script&lang=js&"
export * from "./HomePartnerCard.vue?vue&type=script&lang=js&"
import style0 from "./HomePartnerCard.vue?vue&type=style&index=0&id=6a267cbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a267cbc",
  null
  
)

export default component.exports